import { commitMutation, graphql } from 'react-relay';
import {storeToken} from 'local-util'

const mutation = graphql`
  mutation LoginMutation($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      user {
         id
         name
         companies {
           id
         }
         isSuperadmin
      }
    }
  }
`;

function commit({environment, router, showError, email, password, saveWrapper}) {
  
  return commitMutation(environment, {
    mutation,
    variables: {
      password,
      email
    },
    onError(err) {
      console.log(err)
      saveWrapper.run('onComplete', err)
      saveWrapper.run('onError', err)            
    },
    
    updater(store) {
      const payload = store.getRootField('login');
      storeToken({payload, router, route: 'login'})
      saveWrapper.run('onComplete')
      saveWrapper.run('onSuccess')                  
    },

    optimisticUpdater(store) {
      console.log("Optimistic")
    },
  });
}

export default { commit };
